import React from "react";
import MarkdownView from "react-showdown";

import { useGql } from "../Core/gqlHooks";
import { queryPageSoinsCuirChevelu } from "../Core/services";

import PageHeader from "../Components/pageHeader/PageHeader";

import { setMeta, setPageTitle, setJsonLd } from "../Core/utils";

import "./SoinsCuirChevelu.scss";

const SoinsCuirChevelu = () => {
  const { data, loading } = useGql({
    query: queryPageSoinsCuirChevelu,
  });

  setJsonLd({});
  setPageTitle(data?.soinsCuirChevelu.data?.attributes?.pageTitle);
  setMeta(data?.soinsCuirChevelu.data?.attributes?.keywords);

  return (
    <div className="soins-cuir-chevelu-container page-container">
      <PageHeader title={data?.soinsCuirChevelu.data?.attributes?.title} />
      <div className="main-container">
        <div className="page-content">
          <div className="spacer col-left" />
          <div className="soins-cuir-chevelu col-center">
            <MarkdownView
              markdown={data?.soinsCuirChevelu.data?.attributes?.Description}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default SoinsCuirChevelu;
